import { API_URL } from './backend-url'

const endpoints = {
    hasilCatatanEndpoint: `${API_URL}/hasil/update-catatan`,
    hasilEndpoint: `${API_URL}/hasil/rekrutmen`,
    rekrutmenCatatanSetEndpoint: `${API_URL}/registrasi/update-catatan`,
    rekrutmenDetailEndpoint: `${API_URL}/rekrutmen/detail`,
    rekrutmenGenerateRegistrasiEndpoint: `${API_URL}/registrasi/generate`,
    rekrutmenKlasifikasiEndpoint: `${API_URL}/rekrutmen-klasifikasi`,
    rekrutmenListEndpoint: `${API_URL}/rekrutmen/list`,
    rekrutmenJoinedDashboardEndpoint: `${API_URL}/pelamar/dashboard/lamaran`,
    rekrutmenJoinedEndpoint: `${API_URL}/pelamar/lamaran`,
    rekrutmenListPublicEndpoint: `${API_URL}/rekrutmen`,
    rekrutmenPublikasiEndpoint: `${API_URL}/rekrutmen/proses`,
    rekrutmenRegistrasiSetEndpoint: `${API_URL}/registrasi`,
    rekrutmenRegistrasiGetEndpoint: `${API_URL}/registrasi/rekrutmen`,
    rekrutmenLamaranSayaGetEndpoint: `${API_URL}/pelamar/lamaran/rekrutmen`,
    rekrutmenSetEndpoint: `${API_URL}/rekrutmen`,
    rekrutmenStatusSetEndpoint: `${API_URL}/registrasi/update-status`,
    rekrutmenTahapanEndpoint: `${API_URL}/rekrutmen/tahapan`,
    rekrutmenTitikEndpoint: `${API_URL}/rekrutmen/titik`,
    rekrutmenViewCountEndpoint: `${API_URL}/rekrutmen/lihat`,
    tahapanCatatanEndpoint: `${API_URL}/tahapan/update-catatan`,
    tahapanEndpoint: `${API_URL}/tahapan/rekrutmen`,
    tahapanGenerateEndpoint: `${API_URL}/tahapan/generate`,
    tahapanNilaiEndpoint: `${API_URL}/tahapan/nilai`,
    tahapanStatusEndpoint: `${API_URL}/tahapan/update-status`,

    rekrutmenTerkini: `${API_URL}/tahapan/rekrutmen/terkini`,

    lampiranTahapan: `${API_URL}/tahapan/upload-lampiran`,

    updateStatusHasilEndpoint: `${API_URL}/hasil/update-status`
}

export default endpoints
